import type { default as Candidate } from 'model/Candidate';

import { AnimateSuspense } from 'components/ui/molecules/AnimateSuspense';
import ErrorBoundary from 'components/ui/molecules/ErrorBoundary';
import { RobinSkeleton } from 'components/ui/molecules/RobinSkeleton';
import { AnimatePresence } from 'framer-motion';
import { forwardRef, memo, useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useStyles } from './CandidateCV.styles';
import { CandidateCVErrorFallback } from './CandidateCVErrorFallback';
import { CandidateCVRenderArea } from './CandidateCVRenderArea';

export const CandidateCV = memo(
  forwardRef(
    (
      { candidate, opacity = 1 }: { candidate: Candidate; opacity?: 0 | 1 },
      ref: React.ForwardedRef<HTMLDivElement>,
    ) => {
      const classes = useStyles();
      const { dictionary } = useContext(LocalizationContext);

      return (
        <div ref={ref} css={classes.root} data-candidate-es-id={candidate.es_person_id} style={{ opacity }}>
          <ErrorBoundary fallback={({ error }) => <CandidateCVErrorFallback error={error} />}>
            <AnimateSuspense
              fallback={({ isVisible }) => (
                <AnimatePresence>
                  {isVisible && <RobinSkeleton loadingMessage={dictionary.loadingCandidateCv} css={classes.skeleton} />}
                </AnimatePresence>
              )}>
              <CandidateCVRenderArea candidate={candidate} />
            </AnimateSuspense>
          </ErrorBoundary>
        </div>
      );
    },
  ),
);
